import { useMutation, useQueryClient } from '@tanstack/react-query'
import { insightsRepo } from '@/lib/repositories'
import { analytics } from '@/lib/services/analytics'
import { AnalyticsEvents } from '@/lib/services/analytics-events'

export function useDeleteInsight() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => insightsRepo.deleteInsight(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['insights'] })
      analytics.capture(AnalyticsEvents.INSIGHT_DELETED)
    },
  })
}
